<template>
  <router-view></router-view>
</template>
<script type="text/javascript">
export default {
  name: 'Lead'
}

</script>



// WEBPACK FOOTER //
// src/Crm/containers/Lead.vue